import service from '@/utils/request';

/**
 * 提交出库单
 * @param {Object} data - 出库单数据
 * @returns {Promise}
 */
export function submitSendPlan(data) {
  return service.post('/uic-system_hf/wareout/submit', data);
}

export function immediateWareout(data) {
  return service.post('/uic-system/wareout/immediate-wareout', data);
}

// 新增：根据物料ID、批次查询可用库存export const checkMaterialStock = (materialId, batchNo, storeId) => {
export const checkMaterialStock = (materialId, batchNo) => {
  return service.get('/uic-system_hf/materialstockdetail/getMaterialStockByMaterial', {
    params: {
      materialId: materialId,
      batchNo: batchNo
    }
  });
}


/**
 * 查询供应商
 * @param {string} code - 供应商编码
 * @returns {Promise}
 */
export function getSupplierByCode(code) {
  return service.get('/uic-system/supplier/page', {
    params: {
      current: 1,
      size: 20,
      supplierCode: code
    }
  });
}

/**
 * 查询物料
 * @param {string} materialNo - 物料编码
 * @param {string} supplierId - 供应商ID
 * @returns {Promise}
 */
export function getMaterialBySupplierAndNo(materialNo, supplierId) {
  return service.get('/uic-system_hf/material/page', {
    params: {
      materialNo,
      supplierId,
      type: 1,
      current: 1,
      size: 20,
      isCompose: 0
    }
  });
}

/**
 * 查询主机厂列表
 * @param {Object} params - 查询参数
 * @returns {Promise}
 */
export function getFactories(params) {
  return service.get('/uic-system/factory/list', {
    params
  });
}

/**
 * 查询仓库列表
 * @param {Object} params - 查询参数
 * @param {string} params.subWareId - 子库ID
 * @param {number} params.wareType - 仓库类型（4表示正确类型）
 * @param {string} params.bizDept - 业务部门ID
 * @param {number} params.current - 当前页码
 * @param {number} params.size - 每页条数
 * @param {string} params.wareName - 仓库名称（可选）
 * @returns {Promise}
 */
export function getWarehouses(params) {
  return service.get('/uic-system/ware/page', { params });
}